import React, { useEffect, useRef, useState } from "react";
import CoachLayout from "../../layouts/CoachLayout";
import MenuLayout from "../../layouts/MenuLayout";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import {
  fetchCoachCategories,
  getAllEBooksListCoach,
} from "../../redux/features/coach/actions/authAction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import EBookSlider from "../../components/slider/EBookSlider";
import { enterPrisesPaths } from "../../routes/enterprises";

export const FindCoach = () => {
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { categoryList, isLoading, getAllEBookList } = useSelector(
    (state) => state.coach.auth
  );

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  const [searchByName, setSearchByName] = useState("");
  const [searchByCoachingType, setSearchByCoachingType] = useState(
    state?.data ?? ""
  );
  const [formateFilter, setFormateFilter] = useState("");
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
    dispatch(fetchCoachCategories());
    dispatch(getAllEBooksListCoach({ payload: "?content_type=eBook" }));
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchSearchName =
      !searchByName ||
      item?.full_name?.toLowerCase().includes(searchByName.toLowerCase());
    const matchCoachingType =
      !searchByCoachingType ||
      item?.category_name
        ?.toLowerCase()
        .includes(searchByCoachingType.toLowerCase());

    const formate = formateFilter
      ? item?.format
        ?.toLowerCase()
        .includes(formateFilter.toLowerCase())
      : true;
    return matchCoachingType && matchSearchName && formate;
  });

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      <section class="ct_px_40    py-5">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-xxl-7 col-xl-7 col-md-8 mb-4 mb-md-0 "
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_px_40 ct_px_0_767">
                <h2 class="ct_fs_50_new mb-4 " style={{ maxWidth: "550px" }}>
                  The Right Coach, Just for{" "}
                  <span class="ct_yellow_text">You</span>
                </h2>
                <p class="mb-0 mt-3 ct_fs_20 " style={{ maxWidth: "600px" }}>
                  Browse our network of experienced coaches and choose someone
                  who understands your goals whether you're building a business,
                  leading a team, or making a life shift.
                </p>
                <div class="ct_mt_40">
                  <a
                    class="ct_yellow_btn   px-5 ct_fit_content ct_h_48"
                    onClick={() =>
                      navigate(coachPaths?.ContactUs, {
                        state: { data: "landing" },
                      })
                    }
                  >
                    Talk to Us
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xxl-5 col-xl-5 col-md-4 mb-4 mb-md-0 "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_boocamp_img_left" style={{ aspectRatio: "4/3" }}>
                <img
                  src="assets/img/brecome-a-coach_right.png"
                  alt=""
                  class="ct_img_h_458 w-100 h-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_coach_created_bg ct_pt_30_pb_76 ct_px_100 ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-8 col-xl-7 col-lg-6 col-md-10 mx-auto">
              <h2 className="ct_fs_32 text-center mb-4">
                Find a Coach That Fits You
              </h2>
              <p className="ct_fs_20 text-center">
                Browse our network of expert coaches by type, focus, or
                availability
              </p>
              <div className="position-relative mt-4">
                <input
                  type="search"
                  className="form-control ct_input ct_input_ps_40 bg-transparent" style={{ lineHeight: "auto" }}
                  placeholder="Search by coach name"
                  value={searchByName}
                  onChange={(e) => setSearchByName(e.target.value)}
                />
                <i className="fa-solid fa-search ct_input_icon_left"></i>
              </div>

              <div className="d-flex align-items-center gap-3 mt-4 ct_flex_col_767 ct_w_100_767">
                <div className="ct_w_100_767 position-relative">
                  <select
                    className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767 ct_line_h_auto"
                    value={searchByCoachingType}
                    onChange={(e) => setSearchByCoachingType(e.target.value)}
                  >
                    <option value="">All</option>
                    {categoryList?.length != 0 &&
                      categoryList?.map((item) => (
                        <option value={item?.category_name}>
                          {item?.category_name}
                        </option>
                      ))}
                  </select>
                  <i className="fa-solid fa-angle-down ct_show_eye" style={{ pointerEvents: "none" }}></i>
                </div>
                <div className="ct_w_100_767 position-relative">
                  <select className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767 ct_line_h_auto " >
                    <option>Focus Area</option>
                    <option>Strategy</option>
                    <option>Mindset</option>
                    <option>Accountability</option>
                    <option>Clarity</option>
                  </select>
                  <i className="fa-solid fa-angle-down ct_show_eye" style={{ pointerEvents: "none" }}></i>
                </div>
                <div className="ct_w_100_767 position-relative">
                  <select
                    value={formateFilter}
                    onChange={(e) => setFormateFilter(e.target.value)}
                    className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767 ct_line_h_auto "
                  >
                    <option value={""}>All</option>
                    {[
                      { label: "1:1", val: "1:1" },
                      { label: "Group", val: "GROUP" },
                      { label: "Both", val: "BOTH" },
                    ]?.map((item, ind) => {
                      return <option value={item?.val}>{item?.label}</option>;
                    })}
                  </select>
                  <i className="fa-solid fa-angle-down ct_show_eye" style={{ pointerEvents: "none" }}></i>
                </div>
                <div className="position-relative ct_w_100_767 w-100">
                  <select className="form-control ct_input border-0 bg-transparent w-100 ct_fit_content ct_ps_60 ct_w_100_767 ct_line_h_auto " >
                    <option>Recommended</option>
                    <option>Most Viewed</option>
                    <option>Most Rated</option>
                  </select>
                  <img
                    src="assets/img/filter_circle_icon.png"
                    className="ct_input_icon_left"
                  />
                  <i className="fa-solid fa-angle-down ct_show_eye" style={{ pointerEvents: "none" }}></i>
                </div>
              </div>
            </div>
          </div>

          <div className="row ct_mt_60">
            {displayUsers?.length != 0 &&
              displayUsers?.map((item) => (
                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-md-6 mb-4"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="ct_coach_white_bg h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-start gap-2 ">
                        <img
                          src={item?.profile_image ?? "assets/img/user_44.jpg"}
                          className="ct_flex_shrink_0 ct_img_w_70"
                        />
                        <div>
                          <h4 className="ct_fs_20 mb-2">
                            {item?.full_name ?? ""}
                          </h4>
                          <h6 className="ct_fs_16 mb-3">
                            {item?.category_name ?? ""} Coach
                          </h6>
                          <p
                            className="mb-0 ct_fs_14 ct_grey_text ct_para_scroll ct_custom_scroll"
                            style={{ maxWidth: "224px", maxHeight: "60px" }}
                          >
                            {item?.bio ?? ""}
                          </p>
                        </div>
                      </div>
                      <ul className="d-flex align-items-center gap-2 flex-wrap ct_mt_30">
                        <li>
                          <span className="ct_coach_light_grey_badge">
                            <img src="assets/img/Strategy_icon.png" />
                            Strategy
                          </span>
                        </li>
                        <li>
                          <span className="ct_coach_light_grey_badge">
                            <img src="assets/img/Mindset_icon.png" />
                            Mindset
                          </span>
                        </li>
                        <li>
                          <span className="ct_coach_light_grey_badge">
                            <img src="assets/img/Clarity_icon.png" />
                            Clarity
                          </span>
                        </li>
                        <li>
                          <span className="ct_coach_light_grey_badge">
                            <img src="assets/img/Team_icon.png" />
                            Team
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="mt-auto pt-4 text-center">
                      <a
                        onClick={() =>
                          navigate(`/coach-profile/${item?.coach_id}`, {
                            state: { data: item },
                          })
                        }
                        className="ct_yellow_btn ct_outline_grey ct_outline_dark_blue ct_fit_content px-5 ct_fw_600 ct_btn_border_w_2 ct_h_44 mx-auto"
                      >
                        View Profile
                      </a>
                    </div>
                  </div>
                </div>
              ))}
           
          </div>
        </div>
      </section>

      <section class=" ct_px_40 ct_py_130">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_how_work_img">
                <img src="assets/img/coach_works_img.png" alt="" />
              </div>
            </div>
            <div
              class="col-lg-9 mb-4 mb-lg-0 ps-lg-5"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_how_work_content">
                <h4 class="ct_fs_24_new ct_orange_text">How to Get Started?</h4>
                <h3 class="ct_fs_32 ">
                  Find your coach in three simple steps.
                </h3>
              </div>
              <div class="row mt-5">
                <div class="col-lg-4 col-md-6">
                  <div class="ct_how_work_card p-3">
                    <img
                      src="assets/img/ri_find-replace-fill.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                        Browse Coaches
                      </h5>
                      <p class="mb-0 ct_fs_16" style={{ maxWidth: "252px" }}>
                        Use filters to find the right fit.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="ct_how_work_card p-3">
                    <img
                      src="assets/img/work_icon_2.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                        View Profiles
                      </h5>
                      <p class="mb-0 ct_fs_16" style={{ maxWidth: "252px" }}>
                        Learn about their specialties.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="ct_how_work_card p-3">
                    <img
                      src="assets/img/uim_bag.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                        Book Your Session
                      </h5>
                      <p class="mb-0 ct_fs_16" style={{ maxWidth: "240px" }}>
                        Select your time and get started.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg     ct_p_111_y_106"
        data-aos="fade-left"
        data-aos-duration="1500"
        style={{ backgroundColor: "var(--yellow)" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">Not Sure Where to Start?</h4>
            <p class="mb-0 ct_fs_18">
              Let us match you with a coach based on your needs and goals.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={() =>
                navigate(coachPaths?.ContactUs, { state: { data: "landing" } })
              }
            >
              Talk to Us
            </a>
          </div>
        </div>
      </section>

      <section className="ct_px_40 ct_py_130">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h2 className="ct_fs_32 text-center mb-3">Featured Coaches</h2>
              <p className=" ct_fs_20 text-center">
                Coaches our clients trust and keep coming back to.
              </p>
            </div>
          </div>
          <div
            className="row ct_mt_60"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <Swiper
              modules={[Navigation, Autoplay, Pagination]}
              loop={true}
              slidesPerView={5}
              spaceBetween={30}
              navigation
              pagination={{ clickable: true }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 5 },
              }}
              className="ct_become_coach_slider"
            >
              <SwiperSlide>
                <figure className="ct_featured_coach_card">
                  <div className="ct_featured_card_img">
                    <img src="assets/img/Featured_Coaches_img_9.png" alt="" />
                  </div>
                  <figcaption>
                    <h4 className="ct_fs_20 ct_fw_600 mb-1">Jason Reed</h4>
                    <p className="mb-0 ct_grey_text">Business Coach</p>
                  </figcaption>
                </figure>
              </SwiperSlide>
              <SwiperSlide>
                <figure className="ct_featured_coach_card">
                  <div className="ct_featured_card_img">
                    <img src="assets/img/Featured_Coaches_img_2.jpg" alt="" />
                  </div>
                  <figcaption>
                    <h4 className="ct_fs_20 ct_fw_600 mb-1">Joe Bridges</h4>
                    <p className="mb-0 ct_grey_text">Leadership Coach</p>
                  </figcaption>
                </figure>
              </SwiperSlide>
              <SwiperSlide>
                <figure className="ct_featured_coach_card">
                  <div className="ct_featured_card_img">
                    <img src="assets/img/Featured_Coaches_img_10.png" alt="" />
                  </div>
                  <figcaption>
                    <h4 className="ct_fs_20 ct_fw_600 mb-1">Nellie Padilla</h4>
                    <p className="mb-0 ct_grey_text">Personal Coach</p>
                  </figcaption>
                </figure>
              </SwiperSlide>
              <SwiperSlide>
                <figure className="ct_featured_coach_card">
                  <div className="ct_featured_card_img">
                    <img src="assets/img/Featured_Coaches_img_4.jpg" alt="" />
                  </div>
                  <figcaption>
                    <h4 className="ct_fs_20 ct_fw_600 mb-1">Jeffrey Walters</h4>
                    <p className="mb-0 ct_grey_text">Founder Coach</p>
                  </figcaption>
                </figure>
              </SwiperSlide>
              <SwiperSlide>
                <figure className="ct_featured_coach_card">
                  <div className="ct_featured_card_img">
                    <img src="assets/img/Featured_Coaches_img_5.jpg" alt="" />
                  </div>
                  <figcaption>
                    <h4 className="ct_fs_20 ct_fw_600 mb-1">Dean Bell</h4>
                    <p className="mb-0 ct_grey_text">Frontend Coach</p>
                  </figcaption>
                </figure>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section
        class=" ct_story_light_bg ct_px_40 "
        style={{ backgroundColor: "#F5F3EF" }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div class="d-grid h-100 pt-2 pb-5">
                <h2 class="ct_fs_40">
                  Real Stories, real <span class="ct_yellow_text">success</span>
                </h2>
                <div class="ct_arrows mt-auto d-none d-lg-flex ">
                  <button class="ct_arrow_btn ct_prev" ref={prevRef}>
                    <i class="fa-solid fa-arrow-left"></i>
                  </button>
                  <button class="ct_arrow_btn ct_next" ref={nextRef}>
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-8 mb-4 mb-lg-0">
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                autoplay={{ delay: 2500 }}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                className="ct_real_stories_slider"
              >
                {/* Slide 1 */}
                <SwiperSlide>
                  <div class="ct_story_slide_card">
                    <div class="ct_story_user_img">
                      <img src="assets/img/real_succss_img_457.png" alt="" />
                    </div>
                    <div>
                      <div class="ct_orange_text mb-3">
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                      </div>
                      <h3 class="ct_fs_20 mb-3">
                        Climbing Higher with Every Project
                      </h3>
                      <p
                        class="ct_fS_18 ct_max_w_100_767"
                        style={{ maxWidth: " 402px" }}
                      >
                        NuStar gave me access to exclusive projects that truly
                        challenged and grew my expertise. Today, I lead
                        innovative product initiatives and mentor upcoming tech
                        talents.
                      </p>
                      <div class="mt-5">
                        <h4 class="ct_fs_20">Chloe Adams</h4>
                        <p class="ct_fs_18">Product Director at Zenith Tech</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="ct_story_slide_card">
                    <div class="ct_story_user_img">
                      <img src="assets/img/story_img_user.png" alt="" />
                    </div>

                    <div>
                      <div class="ct_orange_text mb-3">
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                      </div>
                      <h3 class="ct_fs_20 mb-3">
                        Climbing Higher with Every Project
                      </h3>
                      <p class="ct_fS_18" style={{ maxWidth: " 402px" }}>
                        NuStar gave me access to exclusive projects that truly
                        challenged and grew my expertise. Today, I lead
                        innovative product initiatives and mentor upcoming tech
                        talents.
                      </p>
                      <div class="mt-5">
                        <h4 class="ct_fs_20">Chloe Adams</h4>
                        <p class="ct_fs_18">Product Director at Zenith Tech</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                {/* <SwiperSlide>
                  <div class="ct_story_slide_card">
                    <div class="ct_story_user_img">
                      <img src="assets/img/story_img_user.png" alt="" />
                    </div>

                    <div>
                      <div class="ct_orange_text mb-3">
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                      </div>
                      <h3 class="ct_fs_20 mb-3">
                        Climbing Higher with Every Project
                      </h3>
                      <p class="ct_fS_18" style={{ maxWidth: " 402px" }}>
                        NuStar gave me access to exclusive projects that truly
                        challenged and grew my expertise. Today, I lead
                        innovative product initiatives and mentor upcoming tech
                        talents.
                      </p>
                      <div class="mt-5">
                        <h4 class="ct_fs_20">Chloe Adams</h4>
                        <p class="ct_fs_18">Product Director at Zenith Tech</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide> */}
                <SwiperSlide>
                  <div className="ct_story_slide_card">
                    <div className="ct_story_user_img">
                      <img
                        src="../assets/img/reacl_stories_img_slider_123.png"
                        alt=""
                      />
                    </div>
                    <div>
                      <div className="ct_orange_text mb-3">
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                      </div>

                      <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                        From Passion to Profession
                      </h3>

                      <p
                        className="ct_fS_18 ct_darkblue_text"
                        style={{ maxWidth: "402px" }}
                      >
                        Starting as a freelance developer felt overwhelming. But
                        through NuGlow, I built a solid portfolio and connected
                        with startups that valued my work. Today, I lead a team
                        and help others find their way too.
                      </p>

                      <div className="mt-5">
                        <h4 className="ct_fs_20 ct_darkblue_text">
                          Amelia Carter
                        </h4>
                        <p className="ct_fs_18 ct_darkblue_text">
                          Head of Product at BrightWave Solutions
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-right"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg ct_looking_for_work_bg_left ct_mt_100"
        style={{ backgroundColor: "#8ECAE6" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-3" style={{ maxWidth: "700px" }}>
              Still exploring?
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "623px" }}>
              Check out different categories of coaching and see if it’s the
              right fit for you
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={(e) => {
                e.preventDefault();
                navigate(coachPaths?.WebinarData);
              }}
            >
              View Event
            </a>
          </div>
        </div>
      </section>
      {getAllEBookList?.length != 0 && (
        <section class="ct_coach_created_bg ct_px_40 ">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 text-center">
                <h2 class="ct_fs_32">
                  Coach-Created eBooks, Real-World Wisdom
                </h2>
                <p className="ct_fs_20 mx-auto" style={{ maxWidth: "1000px" }}>
                  Get actionable insights, strategies, and tools straight from
                  the coaches who guide founders, leaders, and teams every day.
                </p>
              </div>
              <EBookSlider getAllEBookList={getAllEBookList} />
            </div>
          </div>
        </section>
      )}
      <section
        data-aos="fade-left"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg     ct_p_111_y_106 ct_mt_100"
        style={{ backgroundColor: "var(--orange)" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Looking for More Support Beyond Coaching?
            </h4>
            <p class="mb-0 ct_fs_18 ct_fw_300" style={{ maxWidth: "619px" }}>
              From web design and marketing to sales strategy and customer
              experience, Nuvio offers everything you need to grow with clarity.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={() => navigate(enterPrisesPaths?.ExploreService)}
            >
              Explore Services
            </a>
          </div>
        </div>
      </section>
      <section class=" ct_px_40 pt-0 ct_mt_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_about_cnt">
                <h2 class=" ct_fs_32  ct_mb_60">Frequently asked questions</h2>

                <div class="ct_faq_question_main">
                  <div class="accordion" id="faq_accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faq_one">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_one"
                          aria-expanded="false"
                          aria-controls="collapsefaq_one"
                        >
                          How do I find a coach on NUVIO?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_one"
                        class="accordion-collapse collapse"
                        aria-labelledby="faq_one"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            You don’t need to sign up or create a profile to
                            find a coach. Simply enter your basic details such
                            as your name, email, and phone number—and book a
                            session directly with the coach of your choice.
                            {/* Sign up for an account, complete your profile, and
                            browse our directory of coaches. You can filter by
                            expertise, experience, and coaching style to find
                            the best match for your needs. */}
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqtwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Two"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          What types of coaching are available?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Two"
                        class="accordion-collapse collapse "
                        aria-labelledby="faqtwo"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            NUVIO offers a wide range of coaching, including
                            career coaching, business and entrepreneurship
                            coaching, creative and design coaching, personal
                            development, and skills-specific coaching like
                            Creative AI or freelance growth.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqthree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Three"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Three"
                        >
                          How do I book a session with a coach?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Three"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqthree"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            Once you’ve found a coach that fits your needs, you
                            can book a session directly through their profile.
                            Choose a time that works for you, confirm your
                            booking, and receive a session link or meeting
                            details.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Four"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Four"
                        >
                          How do I know if a coach is the right fit for me?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Four"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFour"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            Review the coach’s profile, experience, and
                            specialties. Many coaches offer introductory calls
                            or discovery sessions so you can assess
                            compatibility before committing to a full program.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFive">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Five"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Five"
                        >
                          Can I contact a coach before booking?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Five"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFive"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            Yes! You can send a message or schedule a short
                            consultation to discuss your goals and see if the
                            coach is the right fit before booking a full
                            session.
                          </p>
                          {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_about_img">
                <img
                  src="assets/img/pexels-fauxels_456.png"
                  class="ct_img_h_617"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <footer class="ct_px_40 py-5">
        <div class="ct_footer_logo">
          <a>
            <img src="assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class="row pt-4">
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
              <ul>
                <li>
                  <a>For Enterprises</a>
                </li>
                <li>
                  <a>For Freelancers</a>
                </li>
                <li>
                  <a>CoachHUB</a>
                </li>
                <li>
                  <a>Funding</a>
                </li>
                <li>
                  <a>About us</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
              <ul>
                <li>
                  <a>Blog</a>
                </li>
                <li>
                  <a>Newsletter</a>
                </li>
                <li>
                  <a>Tutorials</a>
                </li>
                <li>
                  <a>Support</a>
                </li>
                <li>
                  <a>Help Centre</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
              <ul>
                <li>
                  <a href="mailto:hello@nu-vio.com">
                    <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                    hello@nu-vio.com
                  </a>
                </li>
                <li>
                  <a href="tel:+123-456-789">
                    <i class="fa-solid fa-phone me-1 ct_yellow_text"></i>
                    +123-456-789
                  </a>
                </li>
                <li>
                  <a>
                    <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                   Office 36, 1 Exchange Building (TBE), Cybercity, Ebene Mauritius
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
            <div class="ct_newsletter_bg">
              <p>Ready to keep up with what’s next?</p>
              <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                <div class="form-group ct_flex_1 ct_w_100_991">
                  <input
                    type="email"
                    class="form-control ct_input ct_border_radius_100"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="ct_w_100_991">
                  <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                    Subscribe now
                  </button>
                </div>
              </div>
            </div>
            <div class="pt-4">
              <h5 class="ct_fs_18 mb-3">Follow Us</h5>
              <div class="d-flex align-items-center gap-2">
                <a style={{ color: "#0076B2" }}>
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a style={{ color: "#3D5A98" }}>
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a style={{ color: "#FF0000" }}>
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 ct_border_top_1">
          <div class="col-md-12">
            <p class="mb-0 text-center">
              Copyright @ 2025 NUVIO All Rights Reserved
            </p>
          </div>
        </div>
      </footer> */}

      <div
        class="modal fade ct_submit_modal"
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_20 ">Application Submitted</h4>
                <p>
                  Thanks for applying to become a coach on Nuvio CoachHUB. Our
                  team is currently reviewing your application
                </p>
              </div>
              <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <a class="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575">
                  View Coaches
                </a>
                <button
                  class="ct_yellow_btn ct_h_48  px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MenuLayout>
  );
};
